import React, { useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, TextField } from '@mui/material';

import { useCreateBundle } from '~/hooks/apis/bundle/useBundles';

import { bundlePath } from '../nativeTourModel';

interface Props {
  open: boolean;
  onClose: () => void;
}

export default function CreateBundleDialog({ open, onClose }: Props) {
  const navigate = useNavigate();
  const [name, setName] = useState('');

  const createBundle = useCreateBundle();

  const handleClose = () => {
    setName('');
    createBundle.reset();
    onClose();
  };

  const handleSubmit = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      const bundle = await createBundle.mutateAsync(name.trim());
      navigate(bundlePath(bundle.id));
    } catch {
      // The mutation error is shown in the dialog.
    }
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
      <form onSubmit={handleSubmit}>
        <DialogTitle>Create bundle</DialogTitle>
        <DialogContent>
          <Stack spacing={2} pt={1}>
            <TextField
              label="Name"
              value={name}
              onChange={(event) => setName(event.target.value)}
              inputProps={{ maxLength: 255 }}
              required
              autoFocus
            />
            {!!createBundle.error && <Alert severity="error">{createBundle.error.message}</Alert>}
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="submit" variant="contained" disabled={!name.trim() || createBundle.isPending}>
            Create
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
